// src/js/modules/localStoreHandler.js

let defaultCookieExpireDays = 30;
const cookies = {};

const hasLocalStorage = (() => {
    try {
        return typeof window !== 'undefined' && 'localStorage' in window;
    } catch (e) {
        return false;
    }
})();

/**
 * Create cookie
 */
function createCookie(name, value, days = defaultCookieExpireDays, domainName = null) {
    let expires = '';
    let domain = '';

    if (typeof value === 'object') {
        value = JSON.stringify(value);
    }

    if (days !== undefined) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toUTCString();
    }

    if (domainName) {
        domain = '; domain=' + domainName;
    }

    document.cookie = `${name}=${value || ''}${expires}${domain}; path=/`;
    cookies[name] = value;
}

/**
 * Read cookie
 */
function readCookie(name) {
    if (cookies[name] !== undefined) {
        return cookies[name];
    }

    const cookieArr = document.cookie.split('; ');
    for (let i = cookieArr.length - 1; i >= 0; i--) {
        const parts = cookieArr[i].split('=');
        cookies[parts[0]] = parts[1];
    }

    return cookies[name] || null;
}

const localStoreHandler = {

    /**
     * Set default cookie expiration
     */
    setDefaultCookieExpireDays(days) {
        defaultCookieExpireDays = days;
    },

    /**
     * Set value in storage (localStorage preferred)
     */
    set(name, value) {
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }

        if (hasLocalStorage) {
            localStorage.setItem(name, value);
        } else {
            createCookie(name, value);
        }
    },

    /**
     * Get value from storage
     */
    get(name) {
        if (hasLocalStorage) {
            const data = localStorage.getItem(name);

            try {
                return JSON.parse(data);
            } catch {
                return data;
            }
        }

        return readCookie(name);
    },

    /**
     * Remove value
     */
    remove(name) {
        if (hasLocalStorage) {
            localStorage.removeItem(name);
        } else {
            createCookie(name, '', -1);
        }
    },

    /**
     * Cookie-specific APIs
     */
    setCookie(name, value, days, domainName) {
        createCookie(name, value, days, domainName);
    },

    getCookie(name) {
        return readCookie(name);
    },

    removeCookie(name) {
        createCookie(name, '', -1);
    }
};

export default localStoreHandler;
